<template>
  <div class="container button" v-bind:class="{ loading }">
    <input
      :id="id"
      type="button"
      :disabled="loading"
      v-bind:style="{ backgroundColor: color, ...inputStyle }"
      @click="validate"
      :value="label"
    />
  </div>
</template>

<script>
export default {
  name: "SalesButton",
  props: {
    label: String,
    id: String,
    color: {
      type: String,
      default: "#00a5a6",
    },
    inputStyle: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    validate() {
      // Busco el form que lo envuelve (si existe)
      let elem = this.$parent;
      while (elem && !elem.validate) {
        elem = elem.$parent;
      }

      let valid = false;
      if (elem) {
        valid = elem.validate();
      }

      if (valid) {
        this.$emit("click");
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
div.container {
  padding: 0;
  margin: auto;
  display: inline-block;
  width: 100%;
}
input {
  height: 56px;
  border-radius: 1px;
  color: white;
  border: none;
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  width: 100%;
  padding: 0 30px;
  min-width: 128px;
  cursor: pointer;
}

/* Loading */
div.container.loading {
  position: relative;
  overflow: hidden;
}

div.container.loading::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.5);
}

div.container.loading::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  /* width: 100%; */
  height: 4px;
  z-index: 2;
  background-color: #00a5a6;
  animation: animate-line 1s ease-in-out infinite;
}

@keyframes animate-line {
  0% {
    width: 0;
    left: 0;
  }
  50% {
    width: 100%;
  }
  100% {
    left: 100%;
    width: 0;
  }
}
</style>
